/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsV1SweepPlanState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_V1_SWEEP_PLAN_STATE_ENTITY_NAME = 'ixc.sweeps.v1.SweepPlan';
export const ixcSweepsV1SweepPlanStateEntity = new schema.Entity<IxcSweepsV1SweepPlanState>(IXC_SWEEPS_V1_SWEEP_PLAN_STATE_ENTITY_NAME, {}, { idAttribute: 'sweepPlanId' });

